// A form draft seeded from the server's read (Custody settings).
//
// A background refresh used to re-seed every group's draft whenever the server's values changed — wiping what he was
// typing, without a word (Screens and Astra on the setup screens, 27 Oct 2026, minor). Now a newer read re-seeds the
// draft only while it is UNTOUCHED (still equal to what it was seeded from); an edited draft is kept, and `movedUnder`
// says the server changed beneath it — the review then shows the server's current values beside his.

export type Seeded<T> = { draft: T | null; base: string; movedUnder: boolean };

export const SEEDED_EMPTY: Seeded<never> = { draft: null, base: '', movedUnder: false };

/** The draft after a newer server read. Pure. */
export function reseed<T>(s: Seeded<T>, server: T): Seeded<T> {
  const untouched = s.draft === null || JSON.stringify(s.draft) === s.base;
  if (untouched) return { draft: server, base: JSON.stringify(server), movedUnder: false };
  return { ...s, movedUnder: JSON.stringify(server) !== s.base };
}

/** After his save landed: the draft is what the server holds now — untouched again, nothing moved beneath it. Pure. */
export function settled<T>(s: Seeded<T>): Seeded<T> {
  return { ...s, base: JSON.stringify(s.draft), movedUnder: false };
}
